import React from 'react'
import { Box, Typography, makeStyles, Theme } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  maintenanceContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh', // Full viewport height
    backgroundColor: theme.palette.background.default, // Use theme background color
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  maintenanceLogo: {
    maxWidth: '200px', // Adjust as needed
    marginBottom: theme.spacing(4),
  },
  maintenanceMessage: {
    color: theme.palette.text.primary, // Use theme text color
    fontWeight: 600,
    fontSize: '2rem', // Adjust font size
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem', // Smaller font size on small screens
    },
  },
  maintenanceSubMessage: {
    color: theme.palette.text.secondary, // Use theme text color for sub-message
    fontSize: '1rem', // Smaller font size
    marginTop: theme.spacing(2), // Add some space above the sub-message
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem', // Even smaller font size on small screens
    },
  },
}))

const Maintenance: React.FC = () => {
  const classes = useStyles()

  return (
    <Box className={classes.maintenanceContainer}>
      <img
        src='/assets/img/synedrio-logo.png'
        alt='Synedrio Logo'
        className={classes.maintenanceLogo}
      />
      <Typography variant='h4' className={classes.maintenanceMessage}>
        Sito in manutenzione
      </Typography>
      <Typography variant='subtitle1' className={classes.maintenanceSubMessage}>
        Stiamo lavorando per migliorare la tua esperienza sul nostro sito!
      </Typography>
      {/* <Typography variant='h4' className={classes.maintenanceMessage}>
        Servizio sospeso
      </Typography>
      <Typography variant='subtitle1' className={classes.maintenanceSubMessage}>
        Gentile utente, ti informiamo che la piattaforma Synedrio non sarà
        disponibile dalle 08.00 di giovedì 14 Agosto alle 07.00 di lunedì 01
        Settembre per un intervento programmato di adeguamento infrastrutturale.
        In tali date non sarà quindi possibile navigare sul Portale, avviare,
        gestire, o concludere trasmissioni.
      </Typography> */}
    </Box>
  )
}

export default Maintenance
